import { ReactNode } from "react";
import styles from "./Demo.module.css";

function Demo({ children }: { children: ReactNode }) {
  return <div className={styles["root"]}>{children}</div>;
}

export default Demo;
